module.exports = __webpack_public_path__ + "img/ENT.13293cc7.svg";